import React from 'react'
import { ChatSummaryPanel } from 'features/AskMdt/components/ChatSummaryPanel'
import { useChat } from 'features/Chat/ChatContext'
import RoomMessageList from './RoomMessageList'

/**
 * Unlike the old ChatMessageListContainer this renders even with no messages,
 * so an empty room shows its empty state and its day dividers stay available
 * rather than the pane collapsing to nothing above the composer.
 *
 * The summary bar (MYD-650) sits above the messages; it renders nothing for a
 * user without Ask MDT.
 */
const RoomMessageListContainer = () => {
	const {
		state: { currentEventId, currentMessages, userId },
		actions: { editMessage, toggleReaction },
	} = useChat()

	return (
		<>
			<ChatSummaryPanel conversationKey={currentEventId} />
			<RoomMessageList
				currentMessages={currentMessages || []}
				userId={userId}
				onEdit={editMessage}
				onReact={toggleReaction}
			/>
		</>
	)
}

export default RoomMessageListContainer
